import { c as _c } from "react/compiler-runtime";
import type { ButtonThemeType } from '@/constants/project-specific/theme/types';
import React, { useState } from 'react';
import { CopyCheckIcon, CopyIcon } from 'lucide-react';
import { Button, Link, type LinkProps } from "@heroui/react";
interface Props extends LinkProps {
  text: string;
}
function CopyButton(t0) {
  const $ = _c(12);
  let props;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = text;
  } else {
    props = $[1];
    text = $[2];
  }
  const [isCopied, setIsCopied] = useState(false);
  let t1;
  if ($[3] !== text) {
    t1 = () => {
      navigator.clipboard.writeText(text).then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1500);
      }).catch(_temp);
    };
    $[3] = text;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleCopy = t1;
  const t2 = props.size ?? "sm";
  let t3;
  if ($[5] !== isCopied) {
    t3 = isCopied ? <CopyCheckIcon width={15} /> : <CopyIcon width={15} />;
    $[5] = isCopied;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleCopy || $[8] !== props || $[9] !== t2 || $[10] !== t3) {
    t4 = <Link onPress={handleCopy} size={t2} {...props} isExternal={true} showAnchorIcon={true} anchorIcon={t3} />;
    $[7] = handleCopy;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(err) {
  console.error("Failed to copy: ", err);
}
export default CopyButton;